<div>
  <netz-page-heading>Variation details</netz-page-heading>
  <cca-summary [data]="summaryData()" />
</div>
